module.exports = __webpack_public_path__ + "static/media/checkout.e6842414.png";